<ng-container *ngIf="viewModel$ | async as vm">
  <div class="container-fluid p-0 d-flex flex-column flex-grow-1">
    <div class="row no-gutters flex-grow-1">
      <div class="col-12">
        <form [formGroup]="contactFormGroup" class="p-1" autocomplete="off">
          <div class="form-group form-row">
            <label for="sal" class="col-auto col-form-label w-6rem">Title</label>
            <div class="col-auto">
              <ng-select class="w-8rem" labelForId="sal" formControlName="sal" [items]="sals" [multiple]="false"
                [selectOnTab]="true" [closeOnSelect]="true" [virtualScroll]="true" [readonly]="!vm.recordId">
              </ng-select>
            </div>
            <label for="first" class="col-auto col-form-label ml-3">First</label>
            <div class="col-auto">
              <input id="first" formControlName="first" type="text" class="form-control" size="25" autocomplete="off"
                aria-autocomplete="list" [readOnly]="!vm.recordId" />
            </div>
            <label for="last" class="col-auto col-form-label ml-3">Last</label>
            <div class="col-auto">
              <input id="last" formControlName="last" type="text" class="form-control" size="25" autocomplete="off"
                aria-autocomplete="list" [readOnly]="!vm.recordId" />
            </div>
          </div>
          <div class="form-group form-row">
            <label for="company" class="col-auto col-form-label w-6rem">Company</label>
            <div class="col-auto">
              <input id="company" formControlName="company" type="text" class="form-control" size="25"
                autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
            </div>
            <label for="position" class="col-auto col-form-label ml-3">Position</label>
            <div class="col-auto">
              <ng-select class="w-25rem" labelForId="position" formControlName="position"
                [loading]="vm.positions === undefined" [items]="vm.positions || null" [multiple]="false"
                [selectOnTab]="true" [closeOnSelect]="true" [virtualScroll]="true" [addTag]="true"
                [editableSearchTerm]="true" [readonly]="!vm.recordId">
              </ng-select>
            </div>
          </div>
          <div [ngbNavOutlet]="addressNav"></div>
          <div class="form-row">
            <div class="col-12">
              <ul ngbNav #addressNav="ngbNav" [activeId]="vm.addressTab" class="nav-pills justify-content-center">
                <li ngbNavItem="street">
                  <ng-template ngbNavContent>
                    <div class="form-group form-row">
                      <label for="address1" class="col-auto col-form-label w-6rem">
                        Address 1
                      </label>
                      <div class="col-auto">
                        <div class="input-group">
                          <input id="address1" formControlName="address1" type="text" class="form-control" size="50"
                            autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                          <div class="input-group-append"
                            ngbPopover="Address validation license required, contact support team."
                            popoverTitle="Address Lookup" triggers="mouseenter:mouseleave"
                            [disablePopover]="vm.addressLookupClaim">
                            <button class="btn btn-outline-secondary" type="button" [title]="
                                vm.addressLookupClaim ? 'Address Lookup' : ''
                              " (click)="addressLookup()" [disabled]="
                                !vm.addressLookup || !vm.addressLookupClaim
                              ">
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="address2" class="col-auto col-form-label w-6rem">
                        Address 2
                      </label>
                      <div class="col-auto">
                        <input id="address2" formControlName="address2" type="text" class="form-control" size="50"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="suburb" class="col-auto col-form-label w-6rem">
                        {{ suburbLabel }}
                      </label>
                      <div class="col-auto">
                        <input id="suburb" formControlName="suburb" type="text" class="form-control" size="25"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                      <label for="state" class="col-auto col-form-label ml-3">
                        {{ stateLabel }}
                      </label>
                      <div class="col-auto">
                        <input id="state" formControlName="state" type="text" class="form-control" size="25"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                      <label for="postcode" class="col-auto col-form-label ml-3">
                        {{ postcodeLabel }}
                      </label>
                      <div class="col-auto">
                        <input id="postcode" formControlName="postcode" type="text" class="form-control" size="8"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="country" class="col-auto col-form-label w-6rem">
                        Country
                      </label>
                      <div class="col-auto">
                        <input id="country" formControlName="country" type="text" class="form-control" size="25"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li ngbNavItem="mailing">
                  <ng-template ngbNavContent>
                    <div class="form-group form-row">
                      <label for="address1m" class="col-auto col-form-label w-6rem">
                        Address 1
                      </label>
                      <div class="col-auto">
                        <div class="input-group">
                          <input id="address1m" formControlName="address1m" type="text" class="form-control" size="50"
                            autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                          <div class="input-group-append"
                            ngbPopover="Address validation license required, contact support team."
                            popoverTitle="Address Lookup" triggers="mouseenter:mouseleave"
                            [disablePopover]="vm.addressLookupClaim">
                            <button class="btn btn-outline-secondary" type="button" [title]="
                                vm.addressLookupClaim ? 'Address Lookup' : ''
                              " (click)="addressLookup(true)" [disabled]="
                                !vm.addressLookupm || !vm.addressLookupClaim
                              ">
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="address2m" class="col-auto col-form-label w-6rem">
                        Address 2
                      </label>
                      <div class="col-auto">
                        <input id="address2m" formControlName="address2m" type="text" class="form-control" size="50"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="suburbm" class="col-auto col-form-label w-6rem">
                        {{ suburbLabel }}
                      </label>
                      <div class="col-auto">
                        <input id="suburbm" formControlName="suburbm" type="text" class="form-control" size="25"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                      <label for="statem" class="col-auto col-form-label ml-3">
                        {{ stateLabel }}
                      </label>
                      <div class="col-auto">
                        <input id="statem" formControlName="statem" type="text" class="form-control" size="25"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                      <label for="postcodem" class="col-auto col-form-label ml-3">
                        {{ postcodeLabel }}
                      </label>
                      <div class="col-auto">
                        <input id="postcodem" formControlName="postcodem" type="text" class="form-control" size="8"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="countrym" class="col-auto col-form-label w-6rem">
                        Country
                      </label>
                      <div class="col-auto">
                        <input id="countrym" formControlName="countrym" type="text" class="form-control" size="25"
                          autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                      </div>
                    </div>
                  </ng-template>
                </li>
              </ul>
              <div style="position: absolute; bottom: 0; left: 37rem">
                <div class="btn-group btn-group-toggle mb-3 mr-3" ngbRadioGroup name="radioBasic"
                  formControlName="addressTab">
                  <label ngbButtonLabel class="btn-secondary">
                    <input ngbButton type="radio" value="street" />Street
                    Address
                  </label>
                  <label ngbButtonLabel class="btn-secondary">
                    <input ngbButton type="radio" value="mailing" />Mailing
                    Address
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-row">
            <label for="sticykNotes" class="col-auto col-form-label w-6rem">
              Sticky Note
            </label>
            <div class="col-auto">
              <input id="stickyNotes" formControlName="stickyNotes" type="text" class="form-control" size="75"
                autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
            </div>
          </div>
          <div class="form-group form-row">
            <label for="phone1" class="col-auto col-form-label w-6rem">Phone 1</label>
            <div class="col-auto">
              <div class="input-group">
                <input id="phone1" formControlName="phone1" type="text" class="form-control" size="15"
                  autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="dialPhone(vm.phone1)"
                    [disabled]="vm.oncall">
                    <i class="fas fa-phone"></i>
                  </button>
                </div>
              </div>
            </div>
            <label for="mobile" class="col-auto col-form-label w-4rem ml-3">Mobile</label>
            <div class="col-auto">
              <div class="input-group">
                <input id="mobile" formControlName="mobile" type="text" class="form-control" size="15"
                  autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="dialPhone(vm.mobile)"
                    [disabled]="vm.oncall">
                    <i class="fas fa-phone"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-row">
            <label for="phone2" class="col-auto col-form-label w-6rem">Phone 2</label>
            <div class="col-auto">
              <div class="input-group">
                <input id="phone2" formControlName="phone2" type="text" class="form-control" size="15"
                  autocomplete="off" aria-autocomplete="list" [readOnly]="!vm.recordId" />
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" (click)="dialPhone(vm.phone2)"
                    [disabled]="vm.oncall">
                    <i class="fas fa-phone"></i>
                  </button>
                </div>
              </div>
            </div>
            <label for="fax" class="col-auto col-form-label w-4rem ml-3">Fax</label>
            <div class="col-auto">
              <input id="fax" formControlName="fax" type="text" class="form-control" size="15" autocomplete="off"
                aria-autocomplete="list" [readOnly]="!vm.recordId" />
            </div>
          </div>
          <div class="form-group form-row">
            <label for="email1" class="col-auto col-form-label w-6rem">Email</label>
            <div class="col-auto">
              <input id="email1" formControlName="email1" type="text" class="form-control" size="38" autocomplete="off"
                aria-autocomplete="list" [readOnly]="!vm.recordId" />
            </div>
            <label for="web" class="col-auto col-form-label ml-3">Web</label>
            <div class="col-auto">
              <input id="web" formControlName="web" type="text" class="form-control" size="38" autocomplete="off"
                aria-autocomplete="list" [readOnly]="!vm.recordId" />
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-auto">
        <ng-container *ngIf="vm.ibLaunched || (vm.ib && !vm.obLaunched); else obButtons">
          <button [disabled]="vm.testMode || vm.closeDisable || contactFormGroup.invalid || vm.submitting" type="button"
            class="btn btn-secondary w-16-25rem" (click)="closeIB()">Close</button>
        </ng-container>
        <ng-template #obButtons>
          <button [disabled]="vm.testMode || vm.closeDisable || contactFormGroup.invalid || vm.submitting" type="button"
            class="btn btn-secondary w-8rem" (click)="closeOB()">Close</button>
          <button [disabled]="!vm.obLaunched || contactFormGroup.invalid || vm.submitting" type="button"
            class="btn btn-secondary w-8rem ml-1" (click)="next()">Next</button>
        </ng-template>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #addressTemplate let-r="result" let-t="term">
  <ngb-highlight result="{{ r.address1 }}{{ r.address2 ? ', ' + r.address2 : '' }}, {{
      r.suburb
    }} {{ r.state }} {{ r.postcode }}" [term]="t"></ngb-highlight>
</ng-template>